<template>
  <div class="preloader">
    <div class="loader">
      <div class="ytp-spinner">
        <div class="ytp-spinner-container">
          <div class="ytp-spinner-rotator">
            <div class="ytp-spinner-left">
              <div class="ytp-spinner-circle"></div>
            </div>
            <div class="ytp-spinner-right">
              <div class="ytp-spinner-circle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <HeaderSection @emit="scrollPageTo" />
  <router-view />
  <FootSection />
</template>
<script>
import WebDataService from "./services/WebDataService";
import HeaderSection from "./views/HeaderSection";
import FootSection from "./views/FootSection";
import { defineComponent } from "vue";
import axios from "axios";
//import { ref } from "vue";
// import VueScrollTo from 'vue-scrollto'
export default defineComponent({
  name: "TJSL",
  components: {
    HeaderSection,
    FootSection,
  },
  setup() {
    //const wrap = ref();
    const scrollPageTo = (navEl) => {
      // console.log(`#${navEl}`);
      // let element = document.querySelector(`#${navEl}`);
      // let element = navEl;
      // console.log(element);
      setTimeout(() => {
        let element = document.querySelector("[id='" + navEl + "']");
        element.scrollIntoView({ behavior: "smooth" });
        // const container = this.$el.querySelector("#conversation__tram-" + this.counter);
        // container.scrollTop = container.scrollHeight;
        // const el = document.querySelector("[id='" + navEl +"']");
        // console.log(el);
        // window.scrollTo(0,el);
      }, 380);
      // const el = document.querySelector("[id='" + navEl +"']");
      // console.log(el);
      //window.scrollTo(0,el);
      // const rect = this.wrap.wrapper.value.wrapper1.getBoundingClientRect()
      //const rect = wrap.value.wrapper.value.wrapper1.value.getBoundingClientRect();
      //console.log(rect)
      // let element = document.querySelector(`#${navEl}`);
      // console.log(element);
      // element.scrollIntoView({ behavior: "smooth" });
      // VueScrollTo.scrollTo(this.$refs.vidRef, 1000, { easing: 'linear' })
      // console.log(this.$refs.vidRef);
    };

    return {
      scrollPageTo,
    };
  },
  methods: {
    getUserAgent() {
      axios.get("https://geolocation-db.com/json/").then((response) => {
        var deviceType = "";
        // device detection with screen
        // isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        if (
          window.matchMedia(
            "only screen and (min-width: 481px) and (max-width: 820px)"
          ).matches
        ) {
          deviceType = "tablet";
        } else if (
          window.matchMedia("only screen and (max-width: 480px)").matches
        ) {
          deviceType = "mobile";
        } else {
          deviceType = "desktop";
        }

        WebDataService.sendUserAgent(
          1,
          deviceType,
          response.data.country_name,
          response.data.country_code,
          response.data.city,
          response.data.state,
          response.data.latitude,
          response.data.longitude,
          response.data.IPv4
        )
          .then((response) => {
            console.log(response.data);
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },
  },
  mounted() {
    //console.log(this.navEl);
    //console.log(this.rect);
    this.getUserAgent();
  },
});
</script>
